import { useFlagsList } from 'hooks/use-flags-list';
import { useUrlManager } from 'hooks/use-url-manager/use-url-manager';

export const useFlagsInhouse = () => {
  const {
    currentIdentifiers: { organizationId = '' },
  } = useUrlManager();

  const { triggerPreLoginFlagsList, triggerPostLoginFlagsList } = useFlagsList({
    organizationId,
    enabled: false,
  });

  const triggerFlags = async (orgId?: string) => {
    if (orgId) {
      return triggerPostLoginFlagsList(orgId);
    }
    return triggerPreLoginFlagsList();
  };
  return { triggerFlags };
};
